import {AppState} from '../store';

export const getOpenOrdersData = (state: AppState) => state.openOrders.data;
